import React from 'react';
import styled from '@emotion/styled';

import PlusIcon from '../../../assets/icons/plus.svg';
import MinusIcon from '../../../assets/icons/minus.svg';

import SmallPlusIcon from '../../../assets/icons/small-plus.svg';
import SmallMinusIcon from '../../../assets/icons/small-minus.svg';

interface IValueAdjuster {
  field: string;
  value: string;
  isSmallScreen?: boolean;
  onClickPlus?: any;
  onClickMinus?: any;
  icon?: React.ReactNode;
  style?: React.CSSProperties;
}

const ValueAdjuster: React.FC<IValueAdjuster> = ({
  field,
  value,
  isSmallScreen = false,
  onClickPlus,
  onClickMinus,
  icon = null,
  style = {},
}) => {
  return (
    <ValueAdjusterContainer className="value-adjuster-container" style={style}>
      <FieldText
        dangerouslySetInnerHTML={{
          __html: field,
        }}
      />
      {isSmallScreen ? (
        <AdjustmentContainer>
          <div onClick={onClickPlus}>
            <SmallPlusIcon />
          </div>
          <div onClick={onClickMinus}>
            <SmallMinusIcon />
          </div>
        </AdjustmentContainer>
      ) : (
        <AdjustmentContainer>
          <IconWrap onClick={onClickPlus}>
            <PlusIcon />
          </IconWrap>
          <AdjustmentInputWrapper>
            <AdjustmentInput dangerouslySetInnerHTML={{ __html: value }} />
          </AdjustmentInputWrapper>
          <IconWrap onClick={onClickMinus}>
            <MinusIcon />
          </IconWrap>
        </AdjustmentContainer>
      )}
    </ValueAdjusterContainer>
  );
};

export default ValueAdjuster;

const ValueAdjusterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 5px;

  @media screen and (max-width: 840px) {
    width: fit-content;
  }

  &:last-of-type {
    margin-right: -6px;
  }

  svg {
    cursor: pointer;
  }
`;

const FieldText = styled.span`
  margin-bottom: 11px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.23;
  color: #ffffff;
  height: ${13 * 1.23}px;
  text-align: center;

  @media screen and (max-width: 840px) {
    height: unset;
  }
`;

const AdjustmentContainer = styled.div`
  width: 144px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 42px;
  border: solid 1px rgba(255, 255, 255, 0.41);

  @media screen and (max-width: 840px) {
    width: auto;
    height: auto;
    border-radius: 17px;
    padding: 3px 2px;
    flex-direction: column;
    margin-right: 5px;
    margin-left: 5px;

    & > svg {
      width: 29px;
      height: 28px;

      &:first-of-type {
        margin-right: 5px;
      }
    }
  }
`;

const AdjustmentInputWrapper = styled.div`
  width: 45px;
  height: 24px;
  border-radius: 4px;
  background-color: rgba(0, 65, 215, 0.39);
  color: white;
  display: flex;
  margin: 0 15px;
  justify-content: center;
  align-items: center;
`;

const AdjustmentInput = styled.span`
  background-color: transparent;
  border: none;
  color: white;
  text-align: center;
  width: 100%;
  font-weight: 500;
  font-size: 15px;
  line-height: 1.07;
  height: ${15 * 1.07}px;
  color: #ffffff;
  display: flex;
  justify-content: center;
`;

const IconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const ValueIconWrapper = styled.div`
  height: 16px;
  margin-bottom: 3px;

  & > svg {
    height: 16px;
  }
`;
